module.exports = __webpack_public_path__ + "img/task-comment.1329a369.png";